import { Capacitor } from '@capacitor/core';
import { App as AppCap } from '@capacitor/app';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

// Handle back button on native platforms (set logic once on app mount, remove listener on app unmount)
const BackButtonHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) {
      return; // Only run this effect on native platforms
    }
    AppCap.addListener('backButton', ({ canGoBack }) => {
      if (canGoBack) {
        navigate(-1);
      } else {
        AppCap.exitApp();
      }
    });

    return () => {
      AppCap.removeAllListeners(); // Clean up the listener on app unmount
    };
  }, []);

  return null; // No UI, just logic
};

export default BackButtonHandler;